import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Resolve product image URLs: absolute http(s) stay as-is; relative /api paths
// (from object storage) are prefixed with the backend origin.
export const resolveImg = (url) => {
    if (!url) return url;
    if (/^https?:\/\//i.test(url)) return url;
    return `${BACKEND_URL}${url.startsWith("/") ? "" : "/"}${url}`;
};

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("lr_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

// Generica para las fichas sin foto: el logo suelto se leia como logo y no como
// producto. No se escribe en foto_url a proposito, para que se siga viendo desde
// el panel cuales faltan y para que la primera foto que se suba pase a principal.
export const IMG_FALLBACK = "/sin-foto.svg";
